import { COMMENTARY_TEXT } from '../consts.ts';

export const structuresCommentarySubSectionProps =
  COMMENTARY_TEXT['dep-cost'].subItems['additionalStructures'];
